import * as Service from './api';

export { Service };
